/**
 * useSiteSignals — 현장별 대표색·빨강/노랑 건수·최상위 사유. GET /schedule/sites/signals
 * 쿼리 키 ['site-signals', { siteIds, status }] — 접두 ['site-signals'] 로 무효화된다.
 * 항상 최신, 오류는 isError 로 노출(폴백 없음).
 */
import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@indipia/shared';
import type { SiteSignal } from '@indipia/shared';
import { getSiteSignals } from '../api/signals';

export interface UseSiteSignalsOptions {
  /** 지정한 현장만(생략하면 사업장 전체) */
  siteIds?: number[];
  status?: string;
  enabled?: boolean;
}

export function useSiteSignals({ siteIds, status, enabled = true }: UseSiteSignalsOptions = {}) {
  const user = useAuthStore(s => s.user);
  const headers = user?.compId ? { 'X-Comp-Id': String(user.compId) } : undefined;
  return useQuery<SiteSignal[]>({
    queryKey: ['site-signals', { siteIds, status }],
    queryFn: () => getSiteSignals({ siteIds, status }, headers),
    enabled,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
}
